import { toShortDate } from '../../../util/shared/tmc-global';
import { normalizeSpecialPaymentType } from '../../../util/shared/ccSpecialPaymentType';

// Re-export so existing call sites/tests can keep importing it from here. The canonical
// implementation lives in util/shared/ccSpecialPaymentType (also used by the store-level
// chokepoint guard in store/tax/ccPayments).
export { normalizeSpecialPaymentType };

// Builds a taxCCPayments record for a counter credit-card payment that was marked
// processed but did NOT complete a live Forte/Payrix charge (a keyed / "phone"
// entry). The normal flow only creates the taxCCPayments record on a successful
// live charge, so these payments otherwise get no record and never appear on the
// Credit Card Summary report. This mirrors the shape produced by fortePosReqMapping
// for a manual entry (transactionId "Not in system").

export const isProcessedCreditDetail = (p) => !!p
  && (p.paymentType || '').trim().toUpperCase() === 'CREDIT'
  && p.ccProcessed === true;

// True when the payment carries a processed credit line (so a CC record is owed).
export const hasUnchargedProcessedCredit = (paymentDetails) => (paymentDetails || [])
  .some(isProcessedCreditDetail);

export const buildManualCCRecord = (upsertItem, paymentNo, todaysDate) => {
  const allTaxDetails = upsertItem.taxDetails || [];
  const creditDetails = (upsertItem.paymentDetails || []).filter(isProcessedCreditDetail);
  const detail = creditDetails[0] || {};
  const amountPaid = Math.round(creditDetails.reduce((acc, d) => acc + (Number(d.amount) || 0), 0) * 100) / 100;
  const taxDetails = allTaxDetails.map((t) => ({
    taxYear: t.taxYear,
    taxId: t.taxId,
    paymentInstallment: 'FINAL',
    detailsCount: allTaxDetails.length,
    taxAmount: t.taxAmt,
    penalty: t.penaltyAmt,
    feeTotal: t.totalFees,
    total: t.total,
  }));
  const record = {
    paymentGateway: 'FORTE',
    paymentNo,
    systemDate: upsertItem.payDate || toShortDate(todaysDate),
    paymentDate: todaysDate,
    merchantId: '',
    lengthOfTaxDetails: allTaxDetails.length,
    transactionId: 'Not in system',
    amountPaid,
    processingFee: 0,
    maskedAccount: null,
    status: 'OUTSTANDING',
    modeOfPayment: 'POS',
    apiLoginKey: '',
    timeChanged: '',
    paidBy: detail.paidBy || '',
    emailAddress: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: 0,
    phoneNo: null,
    chunkID: '',
    isTempRecord: false,
    paymentType: 'CREDIT',
    taxDetails,
  };
  // Only set specialPaymentType when creditType maps to a valid enum value. An
  // unknown/blank brand must leave the field OFF -- "" and null both fail to save.
  const specialPaymentType = normalizeSpecialPaymentType(detail.creditType);
  if (specialPaymentType) {
    record.specialPaymentType = specialPaymentType;
  }
  return record;
};

export default {
  buildManualCCRecord, hasUnchargedProcessedCredit, isProcessedCreditDetail, normalizeSpecialPaymentType,
};
